<template>
  <div class="SingleItem">
    <v-container v-if="item">
      <!-- btn for copying -->
      <v-btn small text class="blue-grey--text mt-3" @click="copyToClipboard">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>

      <!-- snackbar -->
      <v-snackbar top v-model="snackbar" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <!-- text -->
      <v-row>
        <v-col cols="12">
          <v-card class="blue-grey lighten-5 pa-5 mt-3">
            <h3 v-if="item.nodeDescription.class == 'Story'">==Story==</h3>
            <h3 v-else>==Definition==</h3>
            <p
              v-if="item.nodeDescription.groupName == '인물'"
              class="data-word"
            >
              <span v-if="item.birthYear">【{{ item.birthYear }}】</span>
              <span v-if="item.birthYear || item.deathYear">~</span>
              <span v-if="item.deathYear">【{{ item.deathYear }}】.</span>
              <span>{{ item.nodeDescription.hangeul }}.</span>
              <span>{{ item.content }}</span>
            </p>
            <p v-else class="data-word">
              <span>{{ item.content }}</span>
            </p>

            <h3>==Semantic Data==</h3>
            <h5>===Node Description===</h5>
            <p>{|class="wikitable" style="text-align:left"</p>
            <p>
              ! style="width:100px" | id || class || groupName || partName ||
              label || hangeul || hanja || english || infoUrl || iconUrl || note
            </p>
            <p>|-</p>
            <p>
              | [[<span class="data-word">{{ item.nodeDescription.id }}</span
              >]] ||
              <span class="data-word">{{ item.nodeDescription.class }}</span> ||
              <span class="data-word">{{
                item.nodeDescription.groupName
              }}</span>
              ||
              <span class="data-word">{{ item.nodeDescription.partName }}</span>
              || <span class="data-word">{{ item.nodeDescription.label }}</span
              >||
              <span class="data-word">{{ item.nodeDescription.hangeul }}</span>
              ||
              <span class="data-word">{{ item.nodeDescription.hanja }}</span> ||
              <span class="data-word">{{ item.nodeDescription.english }}</span>
              || http://dh.aks.ac.kr/hanyang2/wiki/index.php/<span
                class="data-word"
                >{{ item.nodeDescription.id }}</span
              >
              || &lt;html&gt;&lt;img width="60" src="<span class="data-word">{{
                item.nodeDescription.iconUrl
              }}</span
              >"/&gt;&lt;/html&gt;
            </p>
            <p>|-</p>
            <p>|}</p>
            <p>* [[Ontology:EKC 2022:Class]]</p>
            <h5>===Contextual Relations===</h5>
            <p>{|class="wikitable" style="text-align:left"</p>
            <p>! source || target || relation || attribute || note</p>
            <template v-for="(rel, index) in item.contextualRelation">
              <div :key="`R${index}`">
                <p>|-</p>
                <p>
                  | [[<span class="data-word">{{ rel.source }}</span
                  >]] || [[<span class="data-word">{{ rel.target }}</span
                  >]] || [[<span class="data-word">{{ rel.relation }}</span
                  >]] || <span class="data-word">{{ rel.attribute }}</span
                  >|| <span class="data-word">{{ rel.note }}</span>
                </p>
              </div>
            </template>
            <p>|}</p>
            <p>* [[Ontology:EKC 2022:Relation]]</p>

            <!-- Temporal Data -->
            <template v-if="item.nodeDescription.class == 'Event'">
              <h3>==Temporal Data==</h3>
              <p>{|class="wikitable" style="width:98%"</p>
              <p>! event id || event label || 양력 || 음력 || note</p>
              <p>|-</p>
              <p>
                |
                <span class="data-word">{{ item.nodeDescription.id }}</span> ||
                <span class="data-word">{{ item.nodeDescription.id }}: </span>
                <span class="data-word">{{
                  item.temporalData.eventLabel
                }}</span>
                || <span class="data-word">{{ item.eventStart }} ~</span>
                <span class="data-word">{{ item.eventEnd }}</span> ||
                <span class="data-word">{{}} ~ </span
                ><span class="data-word">{{}}</span> ||
                <span class="data-word">{{ item.temporalData.eventNote }}</span>
              </p>
              <p>|}</p>

              <p>
                * [http://dh.aks.ac.kr/Edu/wiki/index.php/음력-양력 조선시대
                음력-양력 상호참조 검색]
              </p>
            </template>
            <h3>==Web Resource==</h3>
            <p>{|class="wikitable" style="text-align:left"</p>
            <p>! type || resource || title || description/caption || URL</p>
            <template v-for="(res, index) in item.webResources">
              <div :key="`S${index}`">
                <p>|-</p>
                <p>
                  | <span class="data-word">{{ res.type }}</span> ||
                  <span class="data-word">{{ res.resource }}</span> ||
                  <span class="data-word">{{ res.title }}</span> ||
                  <span class="data-word">{{ res.description }}</span
                  >|| <span class="data-word">{{ res.url }}</span>
                </p>
              </div>
            </template>
            <p>|}</p>
            <p>
              * type: 해설, 참고, 원문 / 사진, 동영상, 도면, 그림, 지도,
              3D_지도, 3D_모델
            </p>

            <h3>==Bibliography==</h3>
            <p>{|class="wikitable" style="text-align:left"</p>
            <p>! type || bibliographic index || online resource || url</p>
            <template v-for="(biblio, index) in item.bibliography">
              <div :key="`B${index}`">
                <p>|-</p>
                <p>
                  | <span class="data-word">{{ biblio.type }}</span> ||
                  <span class="data-word">{{ biblio.index }}</span> ||
                  <span v-if="biblio.resource"
                    ><span class="data-word">{{ biblio.resource }}</span></span
                  >
                  || <span class="data-word">{{ biblio.url }}</span>
                </p>
              </div>
            </template>
            <p>|}</p>
            <p>* type: 단행본, 논문, 도록, 자료집</p>
            <p>* online resource: KCI, RISS, DBpia, 네이버 학술정보 .....</p>

            <h3>==Notes==</h3>
            <p>&lt;references/&gt;</p>

            <h3>==Semantic Network Graph==</h3>
            <p>&lt;html&gt;</p>
            <p>
              &lt;iframe width="90%" height="700px"
              src="http://dh.aks.ac.kr/~sandbox/cgi-bin/Story01.py?db=hanyang2021&amp;project=hanyang&amp;key=<span
                class="data-word"
                >{{ item.nodeDescription.id }}</span
              >"&gt;&lt;/iframe>&lt;br/&gt;
            </p>
            <p>
              &lt;input type="button" value="전체화면"
              onclick="location.href='http://dh.aks.ac.kr/~sandbox/cgi-bin/Story01.py?db=hanyang2021&amp;project=hanyang&amp;key=<span
                class="data-word"
                >{{ item.nodeDescription.id }}</span
              >'"&gt;
            </p>
            <p>&lt;/html&gt;</p>
            <p>
              [[분류:한양도성타임머신 2022]] [[분류:<span class="data-word">{{
                item.nodeDescription.class
              }}</span
              >]] [[분류:2022:<span class="data-word">{{ item.user.name }}</span
              >]]
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn
            :loading="loading"
            fab
            dark
            small
            class="pink"
            @click="deleteItem"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { auth } from "../firebase/init";
import { db } from "../firebase/init";

export default {
  name: "SingleItem",
  data() {
    return {
      snackbar: false,
      timeout: 2000,
      text: "Copied the text",
      loading: false,
      item: null,
      user: null,
    };
  },
  created() {
    let user = auth.currentUser;
    db.collection("users")
      .where("id", "==", user.uid)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          this.user = doc.data();
        });
      })
      .then(() => {
        db.collection("items")
          .where("timestamp", "==", this.$route.params.timestamp)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.item = doc.data();
              this.item.id = doc.id;
            });
          });
      });
  },
  methods: {
    deleteItem() {
      this.loading = true;
      db.collection("items")
        .doc(this.item.id)
        .delete()
        .then(() => {
          this.loading = false;
          console.log("success in deleting");
          this.$router.push({ name: "Projects" });
        });
    },
    copyToClipboard() {
      this.snackbar = true;
      let text = document.querySelector(".v-card").innerText;
      text = text.replace(/\n\n/g, "\n");
      navigator.clipboard.writeText(text);
    },
  },
};
</script>

<style>
.single-item {
  padding: 0;
  margin: 0;
}
.data-word {
  color: #ad1457;
  padding: 0;
  margin: 0;
}
.item h3 {
  margin: 20px;
  color: #cfd8dc;
}
.v-application p {
  margin: 0;
  padding: 0;
}
p {
  padding: 0;
  margin: 0;
}
</style>
